import { getHost } from '@utils/appBridge'
import { ACTION_TYPES, type ActionType } from './action'

export enum SubscriptionPlan {
  FREE = 'FREE',
  STANDARD = 'STANDARD',
  PROFESSIONAL = 'PROFESSIONAL',
  UNLIMIT = 'UNLIMIT',
}
export type CurrentShop = {
  name: string
  shopify_domain: string
  email: string
  phone: string
  address: string
  type_app: SubscriptionPlan
  limit_order: number
  limit_draft_order: number
  smtp_error?: boolean
  automation_email_service_blocked?: boolean
}
export interface AppStateType {
  close_welcome_card: boolean
  shop: string
  current_shop: CurrentShop
  default_locale: string
  is_show_free_banner: boolean
  is_show_remove_banner: boolean
  path: string
  query_string: string
}
export const initialState = {
  close_welcome_card: false,
  shop: '',
  current_shop: {
    name: '',
    shopify_domain: '',
    email: '',
    phone: '',
    address: '',
    type_app: SubscriptionPlan.FREE,
    limit_order: 10,
    limit_draft_order: 10,
    smtp_error: false,
    automation_email_service_blocked: false,
  },
  default_locale: '',
  is_show_free_banner: true,
  is_show_remove_banner: true,
  path: '',
  query_string: '',
}

export const getInitialState = () => {
  try {
    const stored = localStorage.getItem('appState')
    if (stored) {
      const parsed = JSON.parse(stored)
      // Có thể bổ sung validate ở đây nếu cần
      return { ...initialState, ...parsed }
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('Cannot parse appState from localStorage', e)
  }
  return { ...initialState }
}

export const AppReducer = (state: AppStateType, action: ActionType) => {
  switch (action.type) {
    case ACTION_TYPES.APP_LOAD_INITIAL_DATA: {
      const payload = action.payload
      return {
        close_welcome_card: false,
        shop: payload.shopify_domain,
        current_shop: {
          name: payload.name,
          shopify_domain: payload.shopify_domain,
          email: '',
          phone: '',
          address: '',
          type_app: SubscriptionPlan.FREE,
          limit_order: payload.limit_order,
          limit_draft_order: payload.limit_draft_order,
          smtp_error: payload.smtp_error,
          automation_email_service_blocked: payload.automation_email_service_blocked,
        },
        default_locale: 'en',
        is_show_free_banner: true,
        is_show_remove_banner: true,
        path: '',
        query_string: `embedded=1&host=${getHost()}&name=&shop=${payload.shopify_domain}`,
      }
    }
    case ACTION_TYPES.CLOSE_FREE_CARD:
      return {
        ...state,
        is_show_free_banner: false,
      }
    case ACTION_TYPES.CLOSE_REMOVE_CARD:
      return {
        ...state,
        is_show_remove_banner: false,
      }
    case ACTION_TYPES.CLOSE_WELCOME_CARD:
      return {
        ...state,
        close_welcome_card: !state.close_welcome_card,
      }
    default:
      return state
  }
}
export default AppReducer
